import React from 'react';

interface IconProps {
  className?: string;
  isActive?: boolean;
}

// App Logo icon
export const AppLogoIcon: React.FC<IconProps> = ({ className }) => (
  <svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M6.80664 0.148438C7.14065 -0.049685 7.55665 -0.0497842 7.89062 0.148438L11.001 1.99512L14.1543 3.76562C14.493 3.95579 14.701 4.31567 14.6963 4.7041L14.6523 8.32031L14.6963 11.9375C14.7009 12.3259 14.493 12.6858 14.1543 12.876L11.001 14.6465L7.89062 16.4922C7.55657 16.6905 7.14069 16.6905 6.80664 16.4922L3.69629 14.6465L0.541992 12.876C0.203384 12.6858 -0.00460854 12.3258 0 11.9375L0.0439453 8.32031L0 4.7041C-0.00467979 4.31577 0.203412 3.95583 0.541992 3.76562L3.69629 1.99512L6.80664 0.148438ZM7.88672 3.33398C7.55269 3.1358 7.13674 3.13574 6.80273 3.33398L5.0625 4.36719L3.29688 5.3584C2.95825 5.54855 2.75026 5.90854 2.75488 6.29688L2.7793 8.32129L2.75488 10.3457C2.75036 10.734 2.95826 11.0941 3.29688 11.2842L5.0625 12.2744L6.80273 13.3076C7.13679 13.5059 7.55266 13.5059 7.88672 13.3076L9.62793 12.2744L11.3926 11.2842C11.7312 11.0941 11.9391 10.734 11.9346 10.3457L11.9102 8.32129L11.9346 6.29688C11.9392 5.9085 11.7313 5.54854 11.3926 5.3584L9.62793 4.36719L7.88672 3.33398Z" fill="#212121" />
    <path d="M8.70238 17.217C8.70238 17.5102 8.94004 17.7479 9.23322 17.7479H11.3566V20.0852H7.04997C6.46362 20.0852 5.98828 19.6099 5.98828 19.0235V15.2227H8.70238V17.217Z" fill="#212121" />
  </svg>
);

// Home icon
export const HomeIcon: React.FC<IconProps> = ({ className, isActive }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M5.41735 9.33381C5.71337 10.484 6.75744 11.3338 8 11.3338C9.24256 11.3338 10.2866 10.484 10.5827 9.33381M7.34513 1.84315L2.82359 5.35991C2.52135 5.59499 2.37022 5.71253 2.26135 5.85973C2.16491 5.99012 2.09307 6.13701 2.04935 6.29319C2 6.4695 2 6.66095 2 7.04386V11.8671C2 12.6139 2 12.9872 2.14532 13.2725C2.27316 13.5233 2.47713 13.7273 2.72801 13.8552C3.01323 14.0005 3.3866 14.0005 4.13333 14.0005H11.8667C12.6134 14.0005 12.9868 14.0005 13.272 13.8552C13.5229 13.7273 13.7268 13.5233 13.8547 13.2725C14 12.9872 14 12.6139 14 11.8671V7.04386C14 6.66095 14 6.4695 13.9506 6.29319C13.9069 6.13701 13.8351 5.99012 13.7386 5.85973C13.6298 5.71253 13.4787 5.59499 13.1764 5.35991L8.65487 1.84315C8.42065 1.66099 8.30354 1.5699 8.17423 1.53489C8.06013 1.504 7.93987 1.504 7.82577 1.53489C7.69646 1.5699 7.57935 1.66099 7.34513 1.84315Z"
      stroke="#22212D"
      strokeOpacity={isActive ? 1 : 0.7}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Query Generator icon (Star)
export const StarIcon: React.FC<IconProps> = ({ className, isActive }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g clipPath="url(#clip0_32_181)">
      <path
        d="M3.00016 14.6663V11.333M3.00016 4.66634V1.33301M1.3335 2.99967H4.66683M1.3335 12.9997H4.66683M8.66683 1.99967L7.51071 5.00558C7.3227 5.4944 7.2287 5.73881 7.08252 5.9444C6.95296 6.12661 6.79376 6.2858 6.61155 6.41536C6.40597 6.56154 6.16156 6.65555 5.67274 6.84356L2.66683 7.99967L5.67274 9.15579C6.16156 9.3438 6.40597 9.4378 6.61155 9.58399C6.79376 9.71355 6.95296 9.87274 7.08252 10.055C7.2287 10.2605 7.3227 10.5049 7.51071 10.9938L8.66683 13.9997L9.82295 10.9938C10.011 10.5049 10.105 10.2605 10.2511 10.055C10.3807 9.87274 10.5399 9.71355 10.7221 9.58399C10.9277 9.4378 11.1721 9.3438 11.6609 9.15579L14.6668 7.99967L11.6609 6.84356C11.1721 6.65555 10.9277 6.56154 10.7221 6.41536C10.5399 6.2858 10.3807 6.12661 10.2511 5.9444C10.105 5.73881 10.011 5.4944 9.82295 5.00558L8.66683 1.99967Z"
        stroke="#22212D"
        strokeOpacity={isActive ? 1 : 0.7}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_32_181">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// Database icon
export const DatabaseIcon: React.FC<IconProps> = ({ className, isActive }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M14 3.33301C14 4.43758 11.3137 5.33301 8 5.33301C4.68629 5.33301 2 4.43758 2 3.33301M14 3.33301C14 2.22844 11.3137 1.33301 8 1.33301C4.68629 1.33301 2 2.22844 2 3.33301M14 3.33301V12.6663C14 13.773 11.3333 14.6663 8 14.6663C4.66667 14.6663 2 13.773 2 12.6663V3.33301M14 7.99967C14 9.10634 11.3333 9.99967 8 9.99967C4.66667 9.99967 2 9.10634 2 7.99967"
      stroke="#22212D"
      strokeOpacity={isActive ? 1 : 0.7}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Edit icon
export const EditIcon: React.FC<IconProps> = ({ className, isActive }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M14 11.9998L13.3332 12.7292C12.9796 13.1159 12.5001 13.3332 12.0001 13.3332C11.5001 13.3332 11.0205 13.1159 10.6669 12.7292C10.3128 12.3432 9.83332 12.1265 9.33345 12.1265C8.83359 12.1265 8.35409 12.3432 7.99998 12.7292M2 13.3332H3.11636C3.44248 13.3332 3.60554 13.3332 3.75899 13.2963C3.89504 13.2637 4.0251 13.2098 4.1444 13.1367C4.27895 13.0542 4.39425 12.9389 4.62486 12.7083L13 4.33316C13.5523 3.78087 13.5523 2.88544 13 2.33316C12.4477 1.78087 11.5523 1.78087 11 2.33316L2.62484 10.7083C2.39424 10.9389 2.27894 11.0542 2.19648 11.1888C2.12338 11.3081 2.0695 11.4381 2.03684 11.5742C2 11.7276 2 11.8907 2 12.2168V13.3332Z"
      stroke="#22212D"
      strokeOpacity={isActive ? 1 : 0.7}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Help Circle icon
export const HelpCircleIcon: React.FC<IconProps> = ({ className }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M6.66667 6.66667C6.84348 6.17811 7.19323 5.77767 7.64664 5.54401C8.10005 5.31035 8.62501 5.2596 9.11814 5.40251C9.61127 5.54542 10.0365 5.87218 10.3097 6.31807C10.5829 6.76396 10.6833 7.29667 10.5913 7.81334C10.4994 8.33001 10.2214 8.79411 9.80948 9.11807C9.39756 9.44203 8.87891 9.60427 8.35 9.57501M8 12.6667H8.00667M14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33333 8 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z"
      stroke="#22212D"
      strokeOpacity={0.68}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Layout Left icon (Collapse sidebar)
export const LayoutLeftIcon: React.FC<IconProps> = ({ className }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M6 2V14M5.2 2H10.8C11.9201 2 12.4802 2 12.908 2.21799C13.2843 2.40973 13.5903 2.71569 13.782 3.09202C14 3.51984 14 4.0799 14 5.2V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2Z"
      stroke="#25212D"
      strokeOpacity={0.7}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Chevrons Left icon (Expand sidebar)
export const ChevronsLeftIcon: React.FC<IconProps> = ({ className }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M10 12L6 8L10 4"
      stroke="#25212D"
      strokeOpacity={0.7}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Bar Chart icon (Analytics)
export const BarChartIcon: React.FC<IconProps> = ({ className, isActive }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M12 13.3333V6.66667M8 13.3333V2.66667M4 13.3333V9.33333"
      stroke="#22212D"
      strokeOpacity={isActive ? 1 : 0.7}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Log Out icon
export const LogOutIcon: React.FC<IconProps> = ({ className, isActive }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8H6"
      stroke="#ef4444"
      strokeOpacity={isActive ? 1 : 0.8}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

